var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      "enableBackground": "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC0000",
    d: "M21.3,34.7c-1.6,0-2.7-1.1-2.7-2.7c0-1.6,1.1-2.7,2.7-2.7h21.3l0,0c1.6,0,2.7,1.1,2.7,2.7c0,1.6-1.1,2.7-2.7,2.7H21.3 L21.3,34.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC0000",
    d: "M32,64C14.4,64,0,49.6,0,32S14.4,0,32,0s32,14.4,32,32S49.6,64,32,64z M32,5.3C17.3,5.3,5.3,17.3,5.3,32 s12,26.7,26.7,26.7s26.7-12,26.7-26.7S46.7,5.3,32,5.3z"
  })))));
};
export default __webpack_public_path__ + "static/media/circle-minus.d593e0c7.svg";
export { SvgComponent as ReactComponent };